module.exports = __webpack_public_path__ + "assets/img/moto-topview.8ddf3075.png";